// import React, { useState, useEffect } from "react";
// import { io } from "socket.io-client";
// import TopImage from "../assets/Images/Display_Top_Banner.webp";
// import { getAllCourtsData } from "../Libs/api";
// import "./Display.css";

// // Individual Scoreboard Component
// const Scoreboard = ({ courtData, index }) => {
//   console.log(index);

//   // If no active match, show empty court (regardless of last match)
//   if (!courtData.hasActiveMatch) {
//     return (
//       <div className="scoreboard-banner">
//         {/* Top orange border - only show for courts in second row and beyond */}
//         {index >= 2 && <div className="top-border"></div>}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             width: "100%",
//           }}
//         >
//           <div className="court-label text-center">COURT {courtData.court}</div>
//         </div>
//         <div className="scoreboard-content">
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               height: "200px",
//               fontSize: "24px",
//               color: "#666",
//             }}
//           >
//             No Active Match
//           </div>
//         </div>
//       </div>
//     );
//   }

//   const match = courtData.match;
//   const currentSet = match.sets.find(
//     (set) => set.setNumber === match.currentSet
//   );
//   const leftScore = currentSet ? currentSet.teamAScore : 0;
//   const rightScore = currentSet ? currentSet.teamBScore : 0;

//   // Calculate sets won
//   const leftSets = match.sets.filter(
//     (set) => set.winner === match.teamA
//   ).length;
//   const rightSets = match.sets.filter(
//     (set) => set.winner === match.teamB
//   ).length;

//   // Get player names
//   const leftPlayers = match.teamA ? match.teamA.split(" & ") : ["", ""];
//   const rightPlayers = match.teamB ? match.teamB.split(" & ") : ["", ""];

//   // Determine serving player
//   const servingPlayer = match.teamAServe ? "left" : "right";

//   // Get team logos
//   const teamALogo =
//     match.teamALogo ||
//     match.teamAPlayer1?.team?.logo ||
//     match.teamAPlayer2?.team?.logo;
//   const teamBLogo =
//     match.teamBLogo ||
//     match.teamBPlayer1?.team?.logo ||
//     match.teamBPlayer2?.team?.logo;

//   return (
//     <div className="scoreboard-banner">
//       {/* Top orange border - only show for courts in second row and beyond */}
//       {index >= 2 && <div className="top-border"></div>}

//       {/* Court label with team logos */}
//       <div
//         className=""
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           width: "100%",
//           gap: "12px",
//         }}
//       >
//         {/* Team A Logo */}
//         {teamALogo && (
//           <div
//             style={{
//               width: "clamp(40px, 5vw, 80px)",
//               height: "clamp(40px, 5vw, 80px)",
//               borderRadius: "50%",
//               overflow: "hidden",
//               backgroundColor: "#fff",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               border: "2px solid #fff",
//               boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//               flexShrink: 0,
//             }}
//             className="logo-team"
//           >
//             <img
//               src={teamALogo}
//               alt="Team A Logo"
//               style={{
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "cover",
//               }}
//               onError={(e) => {
//                 e.target.style.display = "none";
//               }}
//             />
//           </div>
//         )}

//         <div className="court-label text-center">COURT {courtData.court}</div>

//         {/* Team B Logo */}
//         {teamBLogo && (
//           <div
//             style={{
//               width: "clamp(40px, 5vw, 80px)",
//               height: "clamp(40px, 5vw, 80px)",
//               borderRadius: "50%",
//               overflow: "hidden",
//               backgroundColor: "#fff",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               border: "2px solid #fff",
//               boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//               flexShrink: 0,
//             }}
//             className="logo-team"
//           >
//             <img
//               src={teamBLogo}
//               alt="Team B Logo"
//               style={{
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "cover",
//               }}
//               onError={(e) => {
//                 e.target.style.display = "none";
//               }}
//             />
//           </div>
//         )}
//       </div>

//       {/* Main scoreboard content */}
//       <div className="scoreboard-content">
//         {/* Left side players */}
//         <div className="players-section left-players">
//           <div>
//             <div className="player-row">
//               <div className="player-name">{leftPlayers[0] || ""}</div>
//             </div>
//             <div className="player-row">
//               <div className="player-name">{leftPlayers[1] || ""}</div>
//             </div>
//           </div>
//           {servingPlayer === "left" ? (
//             <div className="serving-indicator"></div>
//           ) : (
//             <div className="serving-empty"></div>
//           )}
//         </div>

//         {/* Center scores */}
//         <div className="scores-section">
//           <div className="main-score">
//             <span className="score-number">{leftScore}</span>
//             <span className="score-separator">-</span>
//             <span className="score-number">{rightScore}</span>
//           </div>
//         </div>

//         {/* Right side players */}
//         <div className="players-section right-players">
//           {servingPlayer === "right" ? (
//             <div className="serving-indicator"></div>
//           ) : (
//             <div className="serving-empty"></div>
//           )}

//           <div>
//             <div className="player-row">
//               <div className="player-name">{rightPlayers[0] || ""}</div>
//             </div>
//             <div className="player-row">
//               <div className="player-name">{rightPlayers[1] || ""}</div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="sets-score">
//         <div className="sets-text">
//           <span className="sets-number">{leftSets}</span>
//           <span className="sets-label">SETS</span>
//           <span className="sets-number">{rightSets}</span>
//         </div>
//       </div>
//     </div>
//   );
// };

// const Display = () => {
//   const [courtsData, setCourtsData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [socket, setSocket] = useState(null);

//   // Fetch initial courts data
//   const fetchCourtsData = async () => {
//     try {
//       const response = await getAllCourtsData();
//       if (response.success) {
//         setCourtsData(response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching courts data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // WebSocket connection
//   useEffect(() => {
//     const newSocket = io(
//       // "https://api-third-shot-score-684526581556.asia-south1.run.app",
//       "https://api-third-shot-score-684526581556.asia-south1.run.app",
//       {
//         transports: ["websocket", "polling"],
//         timeout: 20000,
//         reconnection: true,
//         reconnectionAttempts: 5,
//         reconnectionDelay: 1000,
//         reconnectionDelayMax: 5000,
//         maxReconnectionAttempts: 10,
//         forceNew: true,
//       }
//     );

//     // Connection event handlers
//     newSocket.on("connect", () => {
//       console.log("✅ Display WebSocket connected successfully");
//       // Join live score room for real-time updates
//       newSocket.emit("joinLiveScore");
//       // Join display settings room for display configuration updates
//       newSocket.emit("joinDisplaySettings");
//     });

//     newSocket.on("disconnect", (reason) => {
//       console.log("❌ Display WebSocket disconnected:", reason);
//     });

//     newSocket.on("connect_error", (error) => {
//       console.error("❌ Display WebSocket connection error:", error);
//     });

//     newSocket.on("reconnect", (attemptNumber) => {
//       console.log(
//         "🔄 Display WebSocket reconnected after",
//         attemptNumber,
//         "attempts"
//       );
//       // Re-join live score room after reconnection
//       newSocket.emit("joinLiveScore");
//       // Re-join display settings room after reconnection
//       newSocket.emit("joinDisplaySettings");
//     });

//     setSocket(newSocket);

//     return () => {
//       newSocket.close();
//     };
//   }, []);

//   // Handle WebSocket messages
//   useEffect(() => {
//     if (!socket) return;

//     // Listen for all courts data updates
//     socket.on("allCourtsUpdate", (data) => {
//       console.log("📊 Received all courts update:", data);
//       setCourtsData(data.courtsData);
//     });

//     // Listen for individual match updates
//     socket.on("scoreUpdate", () => {
//       console.log("📊 Score update received, refreshing courts data");
//       fetchCourtsData();
//     });

//     socket.on("setEnd", () => {
//       console.log("📊 Set end received, refreshing courts data");
//       fetchCourtsData();
//     });

//     socket.on("serveUpdate", () => {
//       console.log("📊 Serve update received, refreshing courts data");
//       fetchCourtsData();
//     });

//     socket.on("matchEnd", () => {
//       console.log("📊 Match end received, refreshing courts data");
//       fetchCourtsData();
//     });

//     socket.on("activeMatchChange", () => {
//       console.log("📊 Active match change received, refreshing courts data");
//       fetchCourtsData();
//     });

//     socket.on("courtCleared", () => {
//       console.log("📊 Court cleared received, refreshing courts data");
//       fetchCourtsData();
//     });

//     socket.on("undoScore", () => {
//       console.log("📊 Undo score received, refreshing courts data");
//       fetchCourtsData();
//     });

//     return () => {
//       socket.off("allCourtsUpdate");
//       socket.off("scoreUpdate");
//       socket.off("setEnd");
//       socket.off("serveUpdate");
//       socket.off("matchEnd");
//       socket.off("activeMatchChange");
//       socket.off("courtCleared");
//       socket.off("undoScore");
//     };
//   }, [socket]);

//   // Fetch initial data
//   useEffect(() => {
//     fetchCourtsData();
//   }, []);

//   if (loading) {
//     return (
//       <div className="display-container">
//         <div className="image-wrapper">
//           <img src={TopImage} alt="Top Image" className="responsive-image" />
//         </div>
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             height: "400px",
//             fontSize: "24px",
//             color: "#666",
//           }}
//         >
//           Loading courts data...
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="display-container" style={{ padding: 0 }}>
//       <div className="image-wrapper">
//         <img src={TopImage} alt="Top Image" className="responsive-image" />
//       </div>

//       <div className="courts-grid">
//         {courtsData.map((courtData, index) => (
//           <Scoreboard
//             key={courtData.court}
//             courtData={courtData}
//             index={index}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Display;








import React, { useState, useEffect } from "react";
import { io } from "socket.io-client";
import TopImage from "../assets/Images/Display_Top_Banner.webp";
import BottomImage from "../assets/Images/Display_Bottom_Banner.webp";
import { getAllCourtsData } from "../Libs/api";
import "./Display.css";

const PLAYER_NAME_MAX_VISIBLE = 11;

function formatPlayerName(name) {
  const s = name == null ? "" : String(name);
  if (s.length > PLAYER_NAME_MAX_VISIBLE) {
    return `${s.slice(0, PLAYER_NAME_MAX_VISIBLE)}...`;
  }
  return s;
}

function TeamLogo({ src, side }) {
  const cls = `sb-team-logo${side ? ` sb-team-logo--${side}` : ""}`;
  if (!src) {
    return <div className={`${cls} sb-team-logo--empty`} aria-hidden />;
  }
  return (
    <div className={cls}>
      <img
        src={src}
        alt=""
        className="sb-team-logo-img"
        onError={(e) => {
          e.currentTarget.style.visibility = "hidden";
        }}
      />
    </div>
  );
}

function ServeDot({ active }) {
  if (active) {
    return <div className="sb-serve-dot sb-serve-dot--on" aria-hidden />;
  }
  return <div className="sb-serve-dot sb-serve-dot--off" aria-hidden />;
}

/** Center main row: serve · left score · C1 · right score · serve; sides: names + logo only */
function ScoreboardFace({
  courtNum,
  leftPlayers,
  rightPlayers,
  leftScore,
  rightScore,
  leftSets,
  rightSets,
  servingSide,
  teamALogo,
  teamBLogo,
  dimmed,
  showServe,
}) {
  return (
    <div
      className={`scoreboard-face${dimmed ? " scoreboard-face--dimmed" : ""}`}
    >
      <div className="scoreboard-row-main">
        <div className="sb-cluster sb-cluster--left">
          <div className="sb-names sb-names--left">
            <div className="player-row">
              <div className="player-name">
                {formatPlayerName(leftPlayers[0])}
              </div>
            </div>
            <div className="player-row">
              <div className="player-name">
                {formatPlayerName(leftPlayers[1])}
              </div>
            </div>
          </div>
          <TeamLogo src={teamALogo} side="a" />
        </div>

        <div className="sb-center sb-center-stack">
          <div className="sb-main-score-row">
            <ServeDot active={showServe && servingSide === "left"} />
            <span className="sb-main-score-num">{leftScore}</span>
            <div className="sb-court-badge sb-court-badge--between">C{courtNum}</div>
            <span className="sb-main-score-num">{rightScore}</span>
            <ServeDot active={showServe && servingSide === "right"} />
          </div>
          <div className="sb-sets-row">
            <span className="sets-number">{leftSets}</span>
            <span className="sets-label">SETS</span>
            <span className="sets-number">{rightSets}</span>
          </div>
        </div>

        <div className="sb-cluster sb-cluster--right">
          <TeamLogo src={teamBLogo} side="b" />
          <div className="sb-names sb-names--right">
            <div className="player-row">
              <div className="player-name">
                {formatPlayerName(rightPlayers[0])}
              </div>
            </div>
            <div className="player-row">
              <div className="player-name">
                {formatPlayerName(rightPlayers[1])}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Individual Scoreboard Component
const Scoreboard = ({ courtData, index }) => {
  if (!courtData.hasActiveMatch && !courtData.hasLastMatch) {
    return (
      <div className="scoreboard-banner">
        {index !== 0 && <div className="top-border"></div>}
        <div className="scoreboard-content scoreboard-content--empty" id="empty-scoreboard">
          <div className="sb-center sb-center--solo">
            <div className="sb-court-badge">C{courtData.court}</div>
            <div className="sb-empty-label">No Active Match</div>
          </div>
        </div>
      </div>
    );
  }

  if (!courtData.hasActiveMatch && courtData.hasLastMatch && courtData.match) {
    const match = courtData.match;
    const currentSet = match.sets.find(
      (set) => set.setNumber === match.currentSet
    );
    const leftScore = currentSet ? currentSet.teamAScore : 0;
    const rightScore = currentSet ? currentSet.teamBScore : 0;

    const leftSets = match.sets.filter(
      (set) => set.winner === match.teamA
    ).length;
    const rightSets = match.sets.filter(
      (set) => set.winner === match.teamB
    ).length;

    const leftPlayers = match.teamA ? match.teamA.split(" & ") : ["", ""];
    const rightPlayers = match.teamB ? match.teamB.split(" & ") : ["", ""];

    const teamALogo =
      match.teamALogo ||
      match.teamAPlayer1?.team?.logo ||
      match.teamAPlayer2?.team?.logo;
    const teamBLogo =
      match.teamBLogo ||
      match.teamBPlayer1?.team?.logo ||
      match.teamBPlayer2?.team?.logo;

    return (
      <div className="scoreboard-banner">
        {index !== 0 && <div className="top-border"></div>}
        <div className="scoreboard-content">
          <ScoreboardFace
            courtNum={courtData.court}
            leftPlayers={leftPlayers}
            rightPlayers={rightPlayers}
            leftScore={leftScore}
            rightScore={rightScore}
            leftSets={leftSets}
            rightSets={rightSets}
            servingSide={null}
            teamALogo={teamALogo}
            teamBLogo={teamBLogo}
            dimmed
            showServe={false}
          />
        </div>
      </div>
    );
  }

  const match = courtData.match;
  const currentSet = match.sets.find(
    (set) => set.setNumber === match.currentSet
  );
  const leftScore = currentSet ? currentSet.teamAScore : 0;
  const rightScore = currentSet ? currentSet.teamBScore : 0;

  const leftSets = match.sets.filter(
    (set) => set.winner === match.teamA
  ).length;
  const rightSets = match.sets.filter(
    (set) => set.winner === match.teamB
  ).length;

  const leftPlayers = match.teamA ? match.teamA.split(" & ") : ["", ""];
  const rightPlayers = match.teamB ? match.teamB.split(" & ") : ["", ""];

  const servingSide = match.teamAServe ? "left" : "right";

  const teamALogo =
    match.teamALogo ||
    match.teamAPlayer1?.team?.logo ||
    match.teamAPlayer2?.team?.logo;
  const teamBLogo =
    match.teamBLogo ||
    match.teamBPlayer1?.team?.logo ||
    match.teamBPlayer2?.team?.logo;

  return (
    <div className="scoreboard-banner">
      {index !== 0 && <div className="top-border"></div>}
      <div className="scoreboard-content">
        <ScoreboardFace
          courtNum={courtData.court}
          leftPlayers={leftPlayers}
          rightPlayers={rightPlayers}
          leftScore={leftScore}
          rightScore={rightScore}
          leftSets={leftSets}
          rightSets={rightSets}
          servingSide={servingSide}
          teamALogo={teamALogo}
          teamBLogo={teamBLogo}
          dimmed={false}
          showServe
        />
      </div>
    </div>
  );
};

const Display = ({ displaySlot = 1 }) => {
  const slot = Number(displaySlot) === 2 ? 2 : 1;
  const [courtsData, setCourtsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [socket, setSocket] = useState(null);

  // Fetch initial courts data
  const fetchCourtsData = async () => {
    try {
      const response = await getAllCourtsData();
      if (response.success) {
        setCourtsData(response.data);
      }
    } catch (error) {
      console.error("Error fetching courts data:", error);
    } finally {
      setLoading(false);
    }
  };

  // WebSocket connection
  useEffect(() => {
    const newSocket = io(
      // "http://localhost:8080",
      "https://api-third-shot-score-684526581556.asia-south1.run.app",
      {
        transports: ["websocket", "polling"],
        timeout: 20000,
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        maxReconnectionAttempts: 10,
        forceNew: true,
      }
    );

    // Connection event handlers
    newSocket.on("connect", () => {
      console.log("✅ Display WebSocket connected successfully");
      // Join live score room for real-time updates
      newSocket.emit("joinLiveScore");
      newSocket.emit("joinDisplaySettings", { slot });
    });

    newSocket.on("disconnect", (reason) => {
      console.log("❌ Display WebSocket disconnected:", reason);
    });

    newSocket.on("connect_error", (error) => {
      console.error("❌ Display WebSocket connection error:", error);
    });

    newSocket.on("reconnect", (attemptNumber) => {
      console.log(
        "🔄 Display WebSocket reconnected after",
        attemptNumber,
        "attempts"
      );
      // Re-join live score room after reconnection
      newSocket.emit("joinLiveScore");
      newSocket.emit("joinDisplaySettings", { slot });
    });

    setSocket(newSocket);

    return () => {
      newSocket.close();
    };
  }, [slot]);

  // Handle WebSocket messages
  useEffect(() => {
    if (!socket) return;

    // Listen for all courts data updates
    socket.on("allCourtsUpdate", (data) => {
      console.log("📊 Received all courts update:", data);
      setCourtsData(data.courtsData);
    });

    // Listen for individual match updates
    socket.on("scoreUpdate", () => {
      console.log("📊 Score update received, refreshing courts data");
      fetchCourtsData();
    });

    socket.on("setEnd", () => {
      console.log("📊 Set end received, refreshing courts data");
      fetchCourtsData();
    });

    socket.on("serveUpdate", () => {
      console.log("📊 Serve update received, refreshing courts data");
      fetchCourtsData();
    });

    socket.on("matchEnd", () => {
      console.log("📊 Match end received, refreshing courts data");
      fetchCourtsData();
    });

    socket.on("activeMatchChange", () => {
      console.log("📊 Active match change received, refreshing courts data");
      fetchCourtsData();
    });

    socket.on("courtCleared", () => {
      console.log("📊 Court cleared received, refreshing courts data");
      fetchCourtsData();
    });

    socket.on("undoScore", () => {
      console.log("📊 Undo score received, refreshing courts data");
      fetchCourtsData();
    });

    return () => {
      socket.off("allCourtsUpdate");
      socket.off("scoreUpdate");
      socket.off("setEnd");
      socket.off("serveUpdate");
      socket.off("matchEnd");
      socket.off("activeMatchChange");
      socket.off("courtCleared");
      socket.off("undoScore");
    };
  }, [socket]);

  // Fetch initial data
  useEffect(() => {
    fetchCourtsData();
  }, []);

  if (loading) {
    return (
      <div className="display-container">
        <div className="image-wrapper">
          <img src={TopImage} alt="Top Image" className="responsive-image" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "400px",
            fontSize: "24px",
            color: "#666",
          }}
        >
          Loading courts data...
        </div>
      </div>
    );
  }

  return (
    <div className="display-container" style={{ padding: 0 }}>
      <div className="image-wrapper">
        <img src={TopImage} alt="Top Image" className="responsive-image" />
      </div>

      {courtsData.map((courtData, index) => (
        <Scoreboard key={courtData.court} courtData={courtData} index={index} />
      ))}

      <div className="image-wrapper">
        <img
          src={BottomImage}
          alt="Bottom Image"
          className="responsive-image"
        />
      </div>
    </div>
  );
};

export default Display;